import { authApiInstance } from '@/services/api';
import api from '@/services/api';
import type { AuthResponse, LoginCredentials, ChangePasswordData } from '@/types';

export class AuthService {
  static async login(credentials: LoginCredentials): Promise<AuthResponse['data']> {
    const response = await authApiInstance.post<AuthResponse>('/auth/login', credentials);
    return response.data.data;
  }

  static async register(userData: { username: string; password: string }): Promise<AuthResponse['data']> {
    const response = await authApiInstance.post<AuthResponse>('/auth/register', userData);
    return response.data.data;
  }

  static async refreshToken(refreshToken: string): Promise<AuthResponse['data']> {
    const response = await authApiInstance.post<AuthResponse>('/auth/refresh-token', {
      refreshToken
    });
    return response.data.data;
  }

  static async verifyToken(token: string): Promise<{ valid: boolean; user?: any }> {
    const response = await authApiInstance.post('/auth/verify-token', {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data.data;
  }

  static async changePassword(data: ChangePasswordData): Promise<void> {
    await authApiInstance.post('/auth/change-password', data);
  }

  static async logout(): Promise<void> {
    await authApiInstance.post('/auth/logout');
  }

  static async verifyAdmin(): Promise<{ isAdmin: boolean; user?: any }> {
    const response = await api.get('/auth/verify-admin');
    return {
      isAdmin: response.data.isAdmin,
      user: response.data.user
    };
  }

  // Utility per estrarre il token dall'header Authorization
  static extractTokenFromHeader(authHeader: string | null): string | null {
    if (!authHeader || !authHeader.startsWith('Bearer ')) {
      return null;
    }
    return authHeader.split(' ')[1];
  }

  // Utility per verificare se un token è scaduto
  static isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (!payload.exp) {
        return true;
      }
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp < currentTime;
    } catch (error) {
      return true;
    }
  }

  // Utility per ottenere info dal token senza verificarlo
  static decodeToken(token: string): any {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (error) {
      return null;
    }
  }
}

export const authService = new AuthService();